import React from 'react';
import { connect } from 'react-redux';
import { getErrors } from '../../selectors';

export const Notification = ({ dispatch, errors }) => {
  if (!Array.isArray(errors)) return null;

  const errorToDisplay = errors.filter(error => error.property === undefined || error.property === null)[0];
  if (!errorToDisplay) return null;

  const onClickHandler = () => {
    dispatch({ type: 'closeError', error: errorToDisplay });
  };

  return (
    <div className="alert alert-danger container show" role="alert">
      <div className="d-flex">
        <div className="p-2 text-right">
          <i className="material-icons error-icon" aria-hidden="true">error</i>
        </div>
        <div className="p-2">
          <span className="alert-heading">An error has occurred.</span>
          <div className="alert-body"><div className="divHtml" dangerouslySetInnerHTML={{ __html: errorToDisplay.description }} /></div>
        </div>
        <div className="ml-auto p-2">
          <button type="button" className="close" aria-label="Close" onClick={onClickHandler}><i
            className="material-icons close-icon btn-close-error">clear</i></button>
        </div>
      </div>
    </div>
  );
};

export default connect(
  state => ({
    errors: getErrors(state)
  }),
)(Notification);
